import { ALERT } from '../actions/actionTypes';
import initialState from './initialState';

export default function alertReducer(state = initialState.alert, action) {
    if (action.type === ALERT) {
        return action.config;
    }
    return state;
}
